import React from 'react'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { TitleMD } from '@/atoms/Text'
import { HorizontalItemScroller } from '@/molecules/HorizontalItemScroller'
import { SuggestedShowsAndFilmsContent } from '@/services/RecommendationService'
import { RelatedTitleContentV2 } from '@/types/codegen-federation'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { SuggestedContentCard } from './SuggestedContentCard'

interface SuggestedTabProps {
  isMovieOrSpecial?: boolean
  suggestedShowsAndFilms: SuggestedShowsAndFilmsContent
}

export const SuggestedTab: React.FC<SuggestedTabProps> = ({ isMovieOrSpecial, suggestedShowsAndFilms }) => {
  const { t } = useTranslate('watch')

  return (
    <div className="h-full w-full overflow-x-hidden pt-4 lg:pt-8">
      <PaddedContainer fluid>
        <TitleMD aria-label="community-tab-header" weight="bold" className="md:photon-title-md mb-4 mr-auto">
          <Translate t={t} i18nKey="suggestedShowsAndFilms">
            Suggested Shows & Films
          </Translate>
        </TitleMD>
      </PaddedContainer>
      <div className="w-full">
        <HorizontalItemScroller
          arrows
          slidesToScroll={5}
          slidesToShow={5}
          responsive={[
            {
              breakpoint: 1700,
              settings: {
                slidesToScroll: 5,
                slidesToShow: 5,
              },
            },
            {
              breakpoint: 1536,
              settings: {
                slidesToScroll: 4,
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 1400,
              settings: {
                slidesToScroll: 3.5,
                slidesToShow: 3.5,
              },
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToScroll: 3,
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToScroll: 2.5,
                slidesToShow: 2.5,
              },
            },
            {
              breakpoint: 640,
              settings: {
                slidesToScroll: 2,
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToScroll: 1.5,
                slidesToShow: 1.5,
              },
            },
          ]}
          wrapperClassName="w-full px-4 sm:px-8 md:px-12 xl:px-16"
          scrollerClassName="w-full"
          centerPadding="0px"
        >
          {suggestedShowsAndFilms
            ?.filter?.((recommendedItem) => recommendedItem?.title?.image)
            .map((recommendedItem, index) => (
              <SuggestedContentCard
                key={recommendedItem.id}
                recommendedItem={recommendedItem as RelatedTitleContentV2}
                itemIndex={index}
                pagePlacement={isMovieOrSpecial ? 0 : 1}
                className="pr-2"
              />
            ))}
        </HorizontalItemScroller>
      </div>
    </div>
  )
}
